const Footer = () => {
  return (
    <div className="flex mt-auto w-full bottom-0 justify-between text-sm bg-gray-200 p-2">
      <div>
        <span className="pl-2">Made with </span>
        <span className="text-purple-600">❤️</span>
        <span> by <a className="hover:text-arma-blue" href="https://codingstudio.co.in">coding.Studio();</a></span>
      </div>
      <span className="pr-2">©Copyright 2022</span>
    </div>
  );
};

export default Footer;
